import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=96a210ac&scoped=true&"
import script from "./DialogMessage.vue?vue&type=script&lang=ts&"
export * from "./DialogMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a210ac",
  null
  
)

export default component.exports